export function normalizeWarehouseProductName(name: string): string {
  return name
    .replaceAll('/', ' ')
    .replace(/,/g, (_match: string, offset: number, str: string): string => {
      const prevChar = str[offset - 1] ?? '';
      const nextChar = str[offset + 1] ?? '';

      return /\d/.test(prevChar) && /\d/.test(nextChar) ? ',' : ' ';
    })
    .replaceAll(';', ' ')
    .replaceAll(' - ', ' ')
    .replaceAll('EMEA', ' ')
    .replaceAll(/\s{2,}/g, ' ')
    .trim();
}
